import styled from 'styled-components';

const InfographicStyle = styled.div`
  .draggable-box {
    color: white;
    width: 200px;
    overflow: hidden;
  }

  .draggable-box > div {
    display: flex;
    letter-spacing: 1px;
  }

  .infographic-box {
    display: flex;
    flex-direction: row;
  }

  .infographic-box .left {
    float: left;
    width: 90%;
    background-color: green;
  }

  .infographic-box .left .left-inner {
    padding: 5px;
  }

  .infographic-box .right {
    float: right;
    width: 10%;
    background-color: #69cb45;
  }

  .infographic-box .bottom {
    display: flex;
    padding-left: 5px;
    padding-bottom: 2px;
    align-items: baseline;
    background-color: white;
    color: black;
  }

  .infographic-box .id {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.6rem;
  }

  .infographic-box .description {
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 100;
    padding-right: 5px;
  }

  .infographic-box .bottom .value {
    font-size: 1.4rem;
    padding-right: 2px;
  }

  .infographic-box img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export default InfographicStyle;



// WEBPACK FOOTER //
// ./src/components/InfographicStyle/InfographicStyle.js